<template>
  <Modal
    v-model="_value"
    width="900"
    title="添加在网升级订单"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Tabs type="card">
      <TabPane label="必要订单信息">
        <Form :model="replaceDeviceOrder" :rules="rules" :label-width="90">
          <Row>
            <Col span="8">
              <FormItem prop="registrationNum" label="车牌号码">
<!--                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.registrationNum" placeholder="请输入车牌号码">-->
<!--                </Input>-->

                <AutoComplete
                  @on-change="changedata3"
                  clearable
                  v-model="replaceDeviceOrder.vehicleInfo.registrationNum"
                  :data="data3"
                  :filter-method="filterMethod"
                  @on-select="selectvehicle"
                  placeholder="请输入车牌号码"
                  style="width: 144.52px;">
                </AutoComplete>
<!--                <Icon v-if="isok" type="md-checkmark-circle" style="color: chartreuse" size="24"/>-->
<!--                <Icon v-if="isok!=null && !isok" type="md-close-circle" style="color: red" size="24"/>-->
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="color" label="车牌颜色">
                <Select class="field" v-model="replaceDeviceOrder.vehicleInfo.registrationColor">
                  <Option v-for="item in registrationColorOptions" :value="item.value" :key="item.value">
                    {{item.label}}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vin" label="车架号">
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.vin" placeholder="请输入车架号">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="totalAmount" label="应收总金额">
                <InputNumber :min="0" class="field" v-model="replaceDeviceOrder.totalAmount" placeholder="请输入应收总金额"></InputNumber>
              </FormItem>
            </Col>
              <Col span="8">
                <FormItem prop="serviceDateNum" label="服务期时长">
                  <InputNumber :min="0" class="field" v-model="serviceDateNum" controls-outside @on-change="changeServiceDateNum"></InputNumber>
                </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="serviceDatetime" label="服务到期时间">
                <DatePicker class="field" type="date" v-model="replaceDeviceOrder.serviceDatetime"
                            placeholder="选择日期" @on-change="changeServiceDatetime"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="businessType" label="业务类型">
                <Select class="field" v-model="replaceDeviceOrder.businessType">
                  <Option v-for="item in replaceDeviceOrderBusinessType" :value="item.value" :key="item.value">{{item.label}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="engineNum" label="发动机号">
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.engineNum" placeholder="请输入发动机号">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleTypeName" label="车辆类型">
                <Select
                  placeholder="请输入车辆类型名称"
                  v-model="replaceDeviceOrder.vehicleInfo.vehicleType.name"
                  filterable
                  remote
                  :remote-method="searchVehicleType"
                  :loading="searchVehicleTypeLoading"
                  class="field"
                  clearable>
                  <Option v-for="(option, index) in searchVehicleTypeList" :value="option.name" :key="option.name">{{option.name}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="businessUserId" label="跟进业务员">
                <Select class="field" v-model="replaceDeviceOrder.businessUserId">
                  <Option v-for="item in businessUsers" :value="item.id" :key="item.realName != null?item.realName:item.nickName != null?item.nickName:item.name">{{item.realName != null?item.realName:item.nickName != null?item.nickName:item.name}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="qghyptOption" label="全国货运平台">
                <Select class="field" v-model="replaceDeviceOrder.qghyptOption">
                  <Option v-for="item in qghyptOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="billType" label="开票类型">
                <Select class="field" v-model="replaceDeviceOrder.billType">
                  <Option v-for="item in billType" :value="item.value" :key="item.value">{{item.label}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>

          <Row>
            <Col span="8">
              <FormItem prop="isfree" label="订单类型">
                <Select class="field" v-model="replaceDeviceOrder.isfree">
                  <Option v-for="item in orderTypeOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col v-if="replaceDeviceOrder.isfree != 1" span="8">
              <FormItem prop="mliftainsuranceChannelId" label="交强险公司">
                <Select
                  placeholder="请选择交强险公司"
                  v-model="replaceDeviceOrder.vehicleInfo.mliftainsuranceChannelId"
                  filterable
                  remote
                  :remote-method="searchMLIFTAinsuranceChannel"
                  :loading="searchMLIFTAinsuranceChannelLoading"
                  class="field" style="width: 70%;"
                  clearable>
                  <Option v-for="(option, index) in searchMLIFTAinsuranceChannelList" :value="option.id" :key="option.id">{{option.name}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col v-if="replaceDeviceOrder.isfree != 1" span="8">
              <FormItem prop="tiinsuranceChannelId" label="商业险公司">
                <Select
                  placeholder="请选择商业险公司"
                  v-model="replaceDeviceOrder.vehicleInfo.tiinsuranceChannelId"
                  filterable
                  remote
                  :remote-method="searchTIinsuranceChannel"
                  :loading="searchTIinsuranceChannelLoading"
                  class="field" style="width: 70%;"
                  clearable>
                  <Option v-for="(option, index) in searchTIinsuranceChannelList" :value="option.id" :key="option.id">{{option.name}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>

          <Row>
            <Col v-if="replaceDeviceOrder.isfree != 1" span="8">
              <FormItem prop="insured" label="车主/受保人">
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.insured" placeholder="请输入车主/受保人"></Input>
              </FormItem>
            </Col>
            <Col v-if="replaceDeviceOrder.isfree != 1" span="8">
              <FormItem prop="mliftainsurancechannelDatetime" label="交强险到期日">
                <DatePicker type="date" v-model="replaceDeviceOrder.vehicleInfo.mliftainsurancechannelDatetime"
                            placeholder="选择日期"></DatePicker>
              </FormItem>
            </Col>
            <Col v-if="replaceDeviceOrder.isfree != 1" span="8">
              <FormItem prop="tiinsurancechannelDatetime" label="商业险到期日">
                <DatePicker type="date" v-model="replaceDeviceOrder.vehicleInfo.tiinsurancechannelDatetime"
                            placeholder="选择日期"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="receptDatetime" label="是否已收款">
                <RadioGroup v-model="replaceDeviceOrder.receptDatetime">
                  <Radio label="是"></Radio>
                  <Radio label="否"></Radio>
                </RadioGroup>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="urgent" label="是否加急">
                <Space direction="vertical" size="large">
                  <RadioGroup v-model="replaceDeviceOrder.urgent">
                    <Radio label="是"></Radio>
                    <Radio label="否"></Radio>
                  </RadioGroup>
                </Space>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="bookingDatetime" label="预约安装时间">
                <DatePicker type="datetime" v-model="replaceDeviceOrder.bookingDatetime"
                            placeholder="选择日期"></DatePicker>
              </FormItem>
            </Col>
            <Col span="16">
              <FormItem prop="bookingPlace" label="预约安装地点">
                <Input class="field" v-model="replaceDeviceOrder.bookingPlace">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem prop="clientInfoId" label="客户信息">
                <Select
                  placeholder="请选择客户名称"
                  v-model="replaceDeviceOrder.clientInfoId"
                  filterable
                  remote
                  :remote-method="searchClientInfo"
                  :loading="searchClientInfoLoading"
                  class="field" style="width: 60%;"
                  clearable>
                  <Option v-for="(option, index) in searchClientInfoList" :value="option.id" :key="option.id">{{option.name}}</Option>
                </Select>
                <Button type="primary" style="margin-left: 5px;" @click="onAddClientInfoBtn">添加客户信息</Button>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem prop="vehicleOwnerInfoId" label="车辆所有人信息">
                <Select
                  placeholder="请选择车辆所有人名称"
                  v-model="replaceDeviceOrder.vehicleInfo.vehicleOwnerInfoId"
                  filterable
                  remote
                  :remote-method="searchVehicleOwnerInfo"
                  :loading="searchVehicleOwnerInfoLoading"
                  class="field" style="width: 60%;"
                  clearable>
                  <Option v-for="(option, index) in searchVehicleOwnerInfoList" :value="option.id" :key="option.id">{{option.name}}</Option>
                </Select>
                <Button type="primary" style="margin-left: 5px;" @click="onAddVehicleOwnerInfoBtn">添加所有人</Button>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem prop="vehicleInfoGroupId" label="预绑定车辆分组">
                <Select
                  placeholder="请选择车辆分组名称"
                  v-model="replaceDeviceOrder.vehicleInfoGroupId"
                  filterable
                  remote
                  :remote-method="searchVehicleInfoGroup"
                  :loading="searchVehicleInfoGroupLoading"
                  class="field" style="width: 60%;"
                  clearable placement="top">
                  <Option v-for="(option, index) in searchVehicleInfoGroupList" :value="option.id" :key="option.id">{{option.name}}</Option>
                </Select>
                <Button type="primary" style="margin-left: 5px;" @click="onAddClientInfoGroupBtn">添加车辆分组</Button>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormItem prop="attention">
                <Table border highlight-row size="small" height="150" :columns="columns" :stripe="true" :data="content" ref="table"
                       @on-sort-change="sortChange">
                </Table>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="4">
              <FormItem prop="attention" label="重点关注">
                <Checkbox v-model="replaceDeviceOrder.vehicleInfo.attention"></Checkbox>
              </FormItem>
            </Col>
<!--            <Col span="12">-->
<!--              <FormItem prop="attention">-->
<!--                <label>新设备类型：</label>-->
<!--                <Select placeholder="选择设备型号" style="width: 150px"-->
<!--                        v-model="replaceDeviceOrder.newPositioningDeviceModelId"-->
<!--                >-->
<!--                  <Option v-for="(option, index) in positioningDeviceModelOptions" :value="option.value" :key="option.label">{{option.label}}</Option>-->
<!--                </Select>-->
<!--              </FormItem>-->
<!--            </Col>-->
<!--                        <Col span="4">-->
<!--                          <FormItem prop="reInstall">-->
<!--                            <Button type="primary" style="margin-left: 5px;" @click="onDeviceAndFittings">选择设备及配件</Button>-->
<!--                          </FormItem>-->
<!--                        </Col>-->
            <Col span="8">
              <FormItem prop="installerId" label="安装维修员">
                <Select class="field" v-model="replaceDeviceOrder.installerId">
                  <Option v-for="item in installers" :value="item.id" :key="item.realName != null?item.realName:item.nickName != null?item.nickName:item.name">{{item.realName===null?item.name==null?item.nickName:item.name:item.realName}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem prop="orderRemark" label="订单备注">
                <Input class="field" style="width: 80%;" v-model="replaceDeviceOrder.remark" type="textarea">
                </Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </TabPane>
      <TabPane label="车辆基本信息">
        <Form ref="loginForm" :model="replaceDeviceOrder.vehicleInfo" :rules="rules">
          <Row>
            <Col span="8">
              <FormItem prop="registrationNum">
                <label>自定义名称</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.customName" placeholder="请输入自定义名称">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleTypeName">
                <label>车辆类型</label>
                <Select
                  placeholder="请输入车辆类型名称"
                  v-model="replaceDeviceOrder.vehicleInfo.vehicleType.name"
                  filterable
                  remote
                  :remote-method="searchVehicleType"
                  :loading="searchVehicleTypeLoading"
                  class="field"
                  clearable>
                  <Option v-for="(option, index) in searchVehicleTypeList" :value="option.name" :key="option.name">{{option.name}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleBrandName">
                <label>车辆品牌</label>
                <Select
                  placeholder="请输入车辆品牌名称"
                  v-model="replaceDeviceOrder.vehicleInfo.vehicleBrand.id"
                  filterable
                  remote
                  :remote-method="searchVehicleBrand"
                  :loading="searchVehicleBrandLoading"
                  class="field"
                  clearable>
                  <Option v-for="(option, index) in searchVehicleBrandList" :value="option.id" :key="option.id">{{option.name}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="bodyColor">
                <label>车身颜色</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.bodyColor" placeholder="请输入车身颜色">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="engineNum">
                <label>发动机号</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.engineNum" placeholder="请输入发动机号">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleLicenseNum">
                <label>行驶证号</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.vehicleLicenseNum" placeholder="请输入行驶证号">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="unladenMass">
                <label>整备质量(kg)</label>
                <InputNumber class="field" :min="0" v-model="replaceDeviceOrder.vehicleInfo.unladenMass"
                             placeholder="请输入整备质量"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="approvedLoad">
                <label>核准载重(kg)</label>
                <InputNumber class="field" :min="0" v-model="replaceDeviceOrder.vehicleInfo.approvedLoad"
                             placeholder="请输入核准载重"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleUse">
                <label>使用性质</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.vehicleUse" placeholder="请输入使用性质">
                </Input>
              </FormItem>
            </Col>
          </Row>

          <Row>
            <Col span="24">
              <FormItem prop="remark">
                <label>备注</label>
                <Input class="field" style="width: 80%;" v-model="replaceDeviceOrder.vehicleInfo.remark" type="textarea"
                       placeholder="请输入备注">
                </Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </TabPane>
      <TabPane label="车辆基本信息1">
        <Form ref="loginForm" :model="replaceDeviceOrder.vehicleInfo" :rules="rules">
          <Row>
            <Col span="8">
              <FormItem prop="servicePassword">
                <label>服务密码</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.servicePassword" placeholder="请输入服务密码">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleLicenseDistributeDatetime">
                <label>行驶证发证日期</label>
                <DatePicker type="date" v-model="replaceDeviceOrder.vehicleInfo.vehicleLicenseDistributeDatetime"
                            placeholder="选择日期"></DatePicker>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleLicenseReigsterDatetime">
                <label>行驶证注册日期</label>
                <DatePicker type="date" v-model="replaceDeviceOrder.vehicleInfo.vehicleLicenseReigsterDatetime"
                            placeholder="选择日期"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="certificateNum">
                <label>合格证编号</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.certificateNum" placeholder="请输入合格证编号">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="certificateDistributeDatetime">
                <label>合格证发证日期</label>
                <DatePicker class="field" style="width: 60%;" type="date"
                            v-model="replaceDeviceOrder.vehicleInfo.certificateDistributeDatetime"
                            placeholder="选择日期"></DatePicker>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleModelName">
                <label>车辆型号</label>
                <Select
                  placeholder="请输入车辆型号名称"
                  v-model="replaceDeviceOrder.vehicleInfo.vehicleModel.id"
                  filterable
                  remote
                  :remote-method="searchVehicleModel"
                  :loading="searchVehicleModelLoading"
                  class="field"
                  clearable>
                  <Option v-for="(option, index) in searchVehicleModelList" :value="option.id" :key="option.id">{{option.name}}</Option>
                </Select>
              </FormItem   >
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="chassisModel">
                <label>底盘型号</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.chassisModel" placeholder="请输入底盘型号">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="chassisId">
                <label>底盘ID</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.chassisId" placeholder="请输入底盘ID">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="chassisCertificateNum">
                <label>底盘合格证编号</label>
                <Input class="field" style="width: 60%;" v-model="replaceDeviceOrder.vehicleInfo.chassisCertificateNum"
                       placeholder="请输入底盘合格证编号">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="engineModel">
                <label>发动机型号</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.engineModel" placeholder="请输入发动机型号">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="energyType">
                <label>发动机类型</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.energyType" placeholder="请输入发动机类型">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="displacement">
                <label>能耗</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.displacement" placeholder="请输入能耗">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="engineModel">
                <label>发动机型号</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.engineModel" placeholder="请输入发动机型号">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="energyType">
                <label>发动机类型</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.energyType" placeholder="请输入发动机类型">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="displacement">
                <label>排量(ml)</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.displacement" placeholder="请输入排量">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="power">
                <label>功率(kW)</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.power" placeholder="请输入功率">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="energyUsage">
                <label>能耗</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.energyUsage" placeholder="请输入能耗">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="emissionStandard">
                <label>排放标准</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.emissionStandard" placeholder="请输入排放标准">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="manufacturer">
                <label>制造商名称</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.manufacturer" placeholder="请输入制造商名称">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="springPieceCount">
                <label>钢板弹簧片数</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.springPieceCount" placeholder="请输入钢板弹簧片数">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="turnType">
                <label>转向形式</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.turnType" placeholder="请输入转向形式">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="outlineSizeLong">
                <label>外廓尺寸长(mm)</label>
                <InputNumber class="field" style="width: 60%;" :min="0" v-model="replaceDeviceOrder.vehicleInfo.outlineSizeLong"
                             placeholder="请输入外廓尺寸长"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="outlineSizeWidth">
                <label>外廓尺寸宽(mm)</label>
                <InputNumber class="field" style="width: 60%;" :min="0" v-model="replaceDeviceOrder.vehicleInfo.outlineSizeWidth"
                             placeholder="请输入外廓尺寸宽"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="outlineSizeHeight">
                <label>外廓尺寸高(mm)</label>
                <InputNumber class="field" style="width: 60%;" :min="0" v-model="replaceDeviceOrder.vehicleInfo.outlineSizeHeight"
                             placeholder="请输入外廓尺寸高"></InputNumber>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="boxSizeLong">
                <label>货厢内部尺寸长(mm)</label>
                <InputNumber class="field" style="width: 60%;" :min="0" v-model="replaceDeviceOrder.vehicleInfo.boxSizeLong"
                             placeholder="请输入货厢内部尺寸长"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="boxSizeWidth">
                <label>货厢内部尺寸宽(mm)</label>
                <InputNumber class="field" style="width: 60%;" :min="0" v-model="replaceDeviceOrder.vehicleInfo.boxSizeWidth"
                             placeholder="请输入货厢内部尺寸宽"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="boxSizeHeight">
                <label>货厢内部尺寸高(mm)</label>
                <InputNumber class="field" style="width: 60%;" :min="0" v-model="replaceDeviceOrder.vehicleInfo.boxSizeHeight"
                             placeholder="请输入货厢内部尺寸高"></InputNumber>
              </FormItem>
            </Col>
          </Row>

        </Form>
      </TabPane>
      <TabPane label="车辆基本信息2">
        <Form ref="loginForm" :model="replaceDeviceOrder" :rules="rules">
          <Row>
            <Col span="8">
              <FormItem prop="tyreCount">
                <label>轮胎数量</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.tyreCount" placeholder="请输入轮胎数量">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="tyreSpec">
                <label>轮胎规格</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.tyreSpec" placeholder="请输入轮胎规格">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="wheelSpanFront">
                <label>前轮距</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.wheelSpanFront" placeholder="请输入前轮距">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="wheelSpanBack">
                <label>后轮距</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.wheelSpanBack" placeholder="请输入后轮距">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="wheelBase">
                <label>轴距</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.wheelBase" placeholder="请输入轴距">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="axisLoad">
                <label>轴荷(kg)</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.axisLoad" placeholder="请输入轴荷">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="axisCount">
                <label>轴数</label>
                <Input class="field" v-model="replaceDeviceOrder.vehicleInfo.axisCount" placeholder="请输入轴数">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="totalMass">
                <label>总质量(kg)</label>
                <InputNumber :min="0" class="field" v-model="replaceDeviceOrder.vehicleInfo.totalMass" placeholder="请输入总质量">
                </InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="approvedLoadCoefficient">
                <label>载质量利用系数</label>
                <Input class="field" style="width: 50%;" v-model="replaceDeviceOrder.vehicleInfo.approvedLoadCoefficient"
                       placeholder="请输入载质量利用系数">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="towMax">
                <label>准牵引总质量(kg)</label>
                <InputNumber :min="0" style="width: 30%;" class="field" v-model="replaceDeviceOrder.vehicleInfo.towMax"
                             placeholder="请输入准牵引总质量">
                </InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="saddleMax">
                <label>半挂车鞍座最大允许总质量(kg)</label>
                <InputNumber :min="0" class="field" style="width: 30%;" v-model="replaceDeviceOrder.vehicleInfo.saddleMax"
                             placeholder="请输入半挂车鞍座最大允许总质量">
                </InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="cabPeopleCount">
                <label>驾驶室准乘人数(人)</label>
                <InputNumber :min="0" class="field" style="width: 50%;" v-model="replaceDeviceOrder.vehicleInfo.cabPeopleCount"
                             placeholder="请输入驾驶室准乘人数">
                </InputNumber>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="mannedCount">
                <label>额定载客(人)</label>
                <InputNumber :min="0" class="field" v-model="replaceDeviceOrder.vehicleInfo.mannedCount" placeholder="请输入额定载客">
                </InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="speedMax">
                <label>最高设计车速(km/h)</label>
                <InputNumber :min="0" style="width: 40%;" class="field" v-model="replaceDeviceOrder.vehicleInfo.speedMax"
                             placeholder="请输入最高设计车速">
                </InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="productionDatetime">
                <label>车辆制造日期</label>
                <DatePicker type="date" v-model="replaceDeviceOrder.vehicleInfo.productionDatetime"
                            placeholder="选择日期"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem prop="certificateRemark">
                <label>合格证备注</label>
                <Input class="field" style="width: 80%;" v-model="replaceDeviceOrder.vehicleInfo.certificateRemark" type="textarea"
                       placeholder="请输入合格证备注">
                </Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </TabPane>
    </Tabs>
    <add-client-info-modal v-model="addClientInfoModal" :businessUserId="replaceDeviceOrder.businessUserId" @on-success="onSuccess"></add-client-info-modal>
    <add-vehicle-info-group-noparent-modal v-model="addVehicleInfoGroupNoparentModal" :parentGroupId="addVehicleInfoGroupParentId"></add-vehicle-info-group-noparent-modal>
    <add-vehicle-owner-info-modal v-model="addVehicleOwnerInfoModal" @on-success="onSuccess"></add-vehicle-owner-info-modal>
    <add-positioning-device-fittings-modal  v-model="AddPositioningDeviceFittingsModal" :initValue="AddPositioningDeviceFittingsModalId"
                                            :terminalNumValue="AddPositioningDeviceFittingsModalterminalNum" @on-positioningdevicefittings="onPositioningdevicefittings"></add-positioning-device-fittings-modal>

  </Modal>
</template>
<script>

import AddClientInfoModal from '@/view/crm/components/add-client-info-modal'
import AddVehicleInfoGroupNoparentModal from '@/view/crm/components/add-vehicle-info-group-noparent-modal'
import AddVehicleOwnerInfoModal from '@/view/crm/components/add-vehicle-owner-info-modal'
import AddPositioningDeviceFittingsModal from '@/view/im/components/add-positioning-device-fittings-modal'

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'addreplacedeviceordermodal',
  components: {
    AddClientInfoModal,
    AddVehicleInfoGroupNoparentModal,
    AddVehicleOwnerInfoModal,
    AddPositioningDeviceFittingsModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    registrationNumRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '车牌号/车架号二选一填写', trigger: 'blur' }
        ]
      }
    },
    colorRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '车牌颜色不能为空', trigger: 'blur' }
        ]
      }
    },
    vinRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '车牌号/车架号二选一填写', trigger: 'blur' }
        ]
      }
    },
    totalAmountRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '填写金额', trigger: 'blur' }
        ]
      }
    },
    serviceDateNumRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '服务时长', trigger: 'blur' }
        ]
      }
    },
    businessTypeRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '选择业务类型', trigger: 'blur' }
        ]
      }
    },
    vehicleTypeNameRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '填写车辆类型，如：重型厢式货车', trigger: 'blur' }
        ]
      }
    },
    businessUserIdRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '请选择业务员', trigger: 'blur' }
        ]
      }
    },
    qghyptOptionRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '全国货运平台上传类型', trigger: 'blur' }
        ]
      }
    },
    billTypeRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '请选择发票类型', trigger: 'blur' }
        ]
      }
    },
    isfreeRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '请选择订单类型', trigger: 'blur' }
        ]
      }
    },
    clientInfoIdRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '客户信息', trigger: 'blur' }
        ]
      }
    },
    vehicleOwnerInfoIdRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '车辆所有人信息', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {

      // 添加车辆所有人
      addVehicleOwnerInfoModal: false,

      // 添加客户信息
      addClientInfoModal: false,

      // 添加车辆分组
      addVehicleInfoGroupNoparentModal: false,
      addVehicleInfoGroupParentId: null,

      // 添加定位设备配件
      AddPositioningDeviceFittingsModal: false,
      AddPositioningDeviceFittingsModalId: null,

      searchSalesChannelValue: null,
      searchSalesChannelLoading: false,
      searchSalesChannelList: [],

      searchVehicleInfoGroupList: [],
      searchVehicleInfoGroupLoading: false,

      searchVehicleModelLoading: false,
      searchVehicleModelList: [],
      searchClientInfoLoading: false,
      searchClientInfoList: [],
      searchVehicleOwnerInfoLoading: false,
      searchVehicleOwnerInfoList: [],
      searchVehicleTypeLoading: false,
      searchVehicleTypeList: [],
      searchVehicleBrandLoading: false,
      searchVehicleBrandList: [],

      billType: [
        { label: '增值税发票', value: 1 },
        { label: '增值税专用发票', value: 2 },
        { label: '增值税普通发票', value: 3 },
        { label: '增值税电子专用发票', value: 4 },
        { label: '增值税电子普通发票', value: 5 }
      ],

      qghyptOptions: [
        { label: '不需上传', value: 0 },
        { label: '新车上传', value: 1 },
        { label: '旧车转网', value: 2 }
      ],

      // 订单模式
      orderTypeOptions: [
        { label: '自费安装模式', value: 1 },
        { label: '普通免费模式', value: 2 },
        { label: '太好保模式', value: 3 }
      ],

      // 交强险选择
      searchMLIFTAinsuranceChannelList: [],
      searchMLIFTAinsuranceChannelLoading: false,

      // 商业险选择
      searchTIinsuranceChannelList: [],
      searchTIinsuranceChannelLoading: false,

      replaceDeviceOrderBusinessType: [
        { label: '新装', value: 1 },
        { label: '接入', value: 2 },
        { label: '在网升级', value: 3 }
      ],

      registrationColorOptions: [
        { label: '蓝色', value: 1 },
        { label: '黄色', value: 2 },
        { label: '黑色', value: 3 },
        { label: '白色', value: 4 },
        { label: '渐变绿色', value: 5 },
        { label: '黄绿色', value: 6 },
      ],

      content: [],
      columns: [
        // {
        //   title: 'ID',
        //   resizable: true,
        //   key: 'id',
        //   sortable: 'custom',
        //   tooltip: 'true',
        //   minWidth: 70
        // },
        {
          title: '主机号',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          width: 110
        },
        {
          title: '状态',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          width: 80,
          render: function (h, params) {
            if (params.row.serviceState == 0) {
              return h('div', '停止服务')
            } else if (params.row.serviceState == 1) {
              return h('div', '正常')
            }
          }
        },
        {
          title: '设备型号',
          resizable: true,
          key: 'positioningDeviceModelId',
          ellipsis: 'true',
          width: 100,
          render: function (h, params) {
            if (params.row.positioningDeviceModel) {
              let positioningDeviceModel = params.row.positioningDeviceModel
              return h('div', positioningDeviceModel.name)
            } else {
              return h('div', '未知')
            }
            // let positioningDeviceModel = params.row.positioningDeviceModelId
            // if (positioningDeviceModel === 1) {
            //   return h('div', 'BSJ-A6-BD')
            // } else if (positioningDeviceModel === 2) {
            //   return h('div', 'BSJ-GF03')
            // } else if (positioningDeviceModel === 3) {
            //   return h('div', 'BSJ-M11')
            // } else if (positioningDeviceModel === 13) {
            //   return h('div', 'BSJ-A6L')
            // } else if (positioningDeviceModel === 14) {
            //   return h('div', 'BSJ-A7')
            // } else if (positioningDeviceModel === 4) {
            //   return h('div', 'K5')
            // } else if (positioningDeviceModel === 5) {
            //   return h('div', 'D5X')
            // } else if (positioningDeviceModel === 6) {
            //   return h('div', 'G-3G')
            // } else if (positioningDeviceModel === 7) {
            //   return h('div', 'D5X-HDD')
            // } else if (positioningDeviceModel === 8) {
            //   return h('div', 'D5X-XR')
            // } else if (positioningDeviceModel === 9) {
            //   return h('div', 'BSJ-GF06')
            // } else if (positioningDeviceModel === 10) {
            //   return h('div', 'BSJ-RM01')
            // } else if (positioningDeviceModel === 11) {
            //   return h('div', 'HIK-A3')
            // } else if (positioningDeviceModel === 12) {
            //   return h('div', 'HIK-A3L')
            // } else {
            //   return h('div', '未知')
            // }
          }
        },
        {
          title: '到费期',
          resizable: true,
          key: 'serviceDatetime',
          ellipsis: 'true',
          tooltip: 'true',
          width: 110,
          render: function (h, params) {
            if (params.row.serviceDatetime != null) {
              let serviceDatetime = new Date(params.row.serviceDatetime).Format('yyyy年MM月dd日')
              return h('div', serviceDatetime)
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '备注',
          resizable: true,
          key: 'remark',
          ellipsis: 'true',
          tooltip: 'true',
          width: 100
        },
        {
          title: '设备来源',
          resizable: true,
          key: 'sourceType',
          ellipsis: 'true',
          width: 90,
          render: function (h, params) {
            let sourceType = params.row.sourceType
            if (sourceType === 1) {
              return h('div', '新装')
            } else if (sourceType === 2) {
              return h('div', '接入')
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 220,
          render: (h, params) => {
            let display = []

            // return h('div', [
            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    console.log(params.row.id)
                    console.log(this.replaceDeviceOrder.positioningDeviceId)
                    this.positioningDeviceInfoDetailId = params.row.id
                    this.positioningDeviceInfoDetailModal = true
                  }
                }
              }, '详细信息')
            )

            display.push(
              h('Checkbox', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                value: params.row.id,
                on: {
                  'on-change': (val) => {
                    this.replaceDeviceOrder.positioningDeviceId = params.row.id
                    console.log(params.row.id, 10)
                  }
                }
              }, '升级设备(勾选拆除设备)')
            )
            // ])

            return h('div', display)
          }
        }
      ],

      positioningDeviceModelOptions: [
        // { label: 'BSJ-A6-BD', value: 1 },
        // { label: 'BSJ-GF03', value: 2 },
        // { label: 'BSJ-M11', value: 3 },
        // { label: 'BSJ-A6L', value: 13 },
        // { label: 'BSJ-A7', value: 14 },
        // { label: 'K5', value: 4 },
        // { label: 'D5X', value: 5 },
        // { label: 'G-3G', value: 6 },
        // { label: 'D5X-HDD', value: 7 },
        // { label: 'D5X-XR', value: 8 },
        // { label: 'BSJ-GF06', value: 9 },
        // { label: 'BSJ-RM01', value: 10 },
        // { label: 'HIK-A3', value: 11 },
        // { label: 'HIK-A3L', value: 12 }
      ],

      businessUsers: [],
      data3: [],
      isok: null,
      serviceDateNum: null,
      replaceDeviceOrder: {
        totalAmount: 0,
        serviceDatetime: null,
        businessUserId: null,
        businessType: 3,
        multiDevices: false,
        qghyptOption: 0,
        clientInfoId: null,
        remark: null,
        billType: 1,
        vehicleInfoGroupId: null,
        positioningDeviceId: null,
        newPositioningDeviceModelId: null,
        newPositioningDeviceModel: null,
        vehicleInfoId: null,
        isfree: 1,
        vehicleInfo: {
          customName: null,
          registrationNum: null,
          registrationColor: null,
          vin: null,
          bodyColor: null,
          vehicleType: {
            id: null,
            name: null
          },
          vehicleBrand: {
            id: null,
            name: null
          },
          engineNum: null,
          vehicleLicenseNum: null,
          unladenMass: null,
          approvedLoad: null,
          vehicleOwnerInfoId: null,
          servicePassword: null,
          vehicleLicenseDistributeDatetime: null,
          vehicleLicenseReigsterDatetime: null,
          remark: null,
          certificateNum: null,
          certificateDistributeDatetime: null,
          vehicleModel: {
            id: null,
            name: null
          },
          chassisModel: null,
          chassisId: null,
          chassisCertificateNum: null,
          engineModel: null,
          energyType: null,
          displacement: null,
          power: null,
          energyUsage: null,
          emissionStandard: null,
          manufacturer: null,
          outlineSizeLong: null,
          outlineSizeWidth: null,
          outlineSizeHeight: null,
          boxSizeLong: null,
          boxSizeWidth: null,
          boxSizeHeight: null,
          springPieceCount: null,
          tyreCount: null,
          tyreSpec: null,
          wheelSpanFront: null,
          wheelSpanBack: null,
          wheelBase: null,
          axisLoad: null,
          axisCount: null,
          turnType: null,
          totalMass: null,
          approvedLoadCoefficient: null,
          towMax: null,
          saddleMax: null,
          cabPeopleCount: null,
          mannedCount: null,
          speedMax: null,
          productionDatetime: null,
          certificateRemark: null,
          vehicleLicensePictureId: null,
          certificatePictureId: null,
          vehicleSrcLicensePicture1Id: null,
          vehicleSrcLicensePicture2Id: null,
          vehicleBodyPictureId: null,
          vehicleUse: null,
          attention: false,
          mliftainsuranceChannelId: null,
          mliftainsurancechannelDatetime: null,
          tiinsuranceChannelId: null,
          tiinsurancechannelDatetime: null,
          insured: null
        },
        salesChannelId: null,
        urgent: '否',
        receptDatetime: '否',
        stepId: null,
        step: {
          orderId: null,
          state: null,
          lastState: null,
          userId: null,
          user: null,
          result: null
        },
        bookingDatetime: new Date(new Date().setDate(new Date().getDate() + 1)),
        bookingPlace: null,
        actualDatetime: null,
        actualPlace: null
      }
    }
  },
  methods: {
    ...mapActions([
      'ReplaceDeviceOrderServ_AddObj',
      'UserServ_GetAllUsers'
    ]),
    // onDeviceAndFittings () {
    //   this.AddPositioningDeviceFittingsModal = true
    //   this.AddPositioningDeviceFittingsModalId = this._initValue
    // },
    changeServiceDateNum (e) {
      // console.log(e)
      // console.log(new Date().getMonth())
      // console.log(new Date(new Date().setMonth(e)).Format('yyyy-MM-dd'))
      this.replaceDeviceOrder.serviceDatetime = new Date(new Date().setMonth(new Date().getMonth() + e)).Format('yyyy-MM-dd')
      console.log(this.replaceDeviceOrder.serviceDatetime)
    },
    changeServiceDatetime (e) {
      // console.log(e)
      // console.log(new Date(e))
      this.serviceDateNum = new Date(e).getMonth() - new Date().getMonth()
    },
    onAddVehicleOwnerInfoBtn () {
      this.addVehicleOwnerInfoModal = true
    },
    onAddClientInfoBtn () {
      if (!this.replaceDeviceOrder.businessUserId) {
        this.$Message.error('请先选择跟进业务员')
        return
      }
      this.addClientInfoModal = true
    },
    onAddClientInfoGroupBtn () {
      this.addVehicleInfoGroupNoparentModal = true
    },
    onSuccess () {

    },
    searchVehicleType (input) {
      this.searchVehicleTypeLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleTypeList = []
        this.searchVehicleTypeLoading = false
      } else {
        store.dispatch('VehicleTypeServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleTypeList = store.getters.get_VehicleType_SearchByNameResult ? store.getters.get_VehicleType_SearchByNameResult : []
          this.searchVehicleTypeLoading = false
        }).catch(err => {
          this.searchVehicleTypeLoading = false
        })
      }
    },
    searchVehicleBrand (input) {
      this.searchVehicleBrandLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleBrandList = []
        this.searchVehicleBrandLoading = false
      } else {
        store.dispatch('VehicleBrandServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleBrandList = store.getters.get_VehicleBrand_SearchByNameResult ? store.getters.get_VehicleBrand_SearchByNameResult : []
          this.searchVehicleBrandLoading = false
        }).catch(err => {
          this.searchVehicleBrandLoading = false
        })
      }
    },
    searchVehicleOwnerInfo (input) {
      this.searchVehicleOwnerInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleOwnerInfoList = []
        this.searchVehicleOwnerInfoLoading = false
      } else {
        store.dispatch('VehicleOwnerInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleOwnerInfoList = store.getters.get_VehicleOwnerInfo_SearchByNameResult ? store.getters.get_VehicleOwnerInfo_SearchByNameResult : []
          this.searchVehicleOwnerInfoLoading = false
        }).catch(err => {
          this.searchVehicleOwnerInfoLoading = false
        })
      }
    },
    searchVehicleInfoGroup (input) {
      this.searchVehicleInfoGroupLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleInfoGroupList = []
        this.searchVehicleInfoGroupLoading = false
      } else {
        store.dispatch('VehicleInfoGroupServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleInfoGroupList = store.getters.get_VehicleInfoGroup_SearchByNameResult ? store.getters.get_VehicleInfoGroup_SearchByNameResult : []
          this.searchVehicleInfoGroupLoading = false
        }).catch(err => {
          this.searchVehicleInfoGroupLoading = false
        })
      }
    },
    searchSalesChannel (input) {
      this.searchSalesChannelLoading = true
      if (!input || input.length <= 0) {
        this.searchSalesChannelList = []
        this.searchSalesChannelLoading = false
      } else {
        store.dispatch('SalesChannelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchSalesChannelList = store.getters.get_SalesChannel_SearchByNameResult ? store.getters.get_SalesChannel_SearchByNameResult : []
          this.searchSalesChannelLoading = false
        }).catch(err => {
          this.searchSalesChannelLoading = false
        })
      }
    },
    searchClientInfo (input) {
      this.searchClientInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchClientInfoList = []
        this.searchClientInfoLoading = false
      } else {
        store.dispatch('ClientInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchClientInfoList = store.getters.get_ClientInfo_SearchByNameResult ? store.getters.get_ClientInfo_SearchByNameResult : []
          this.searchClientInfoLoading = false
        }).catch(err => {
          this.searchClientInfoLoading = false
        })
      }
    },
    searchVehicleModel (input) {
      this.searchVehicleModelLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleModelList = []
        this.searchVehicleModelLoading = false
      } else {
        store.dispatch('VehicleModelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleModelList = store.getters.get_VehicleModel_SearchByNameResult ? store.getters.get_VehicleModel_SearchByNameResult : []
          this.searchVehicleModelLoading = false
        }).catch(err => {
          this.searchVehicleModelLoading = false
        })
      }
    },
    searchMLIFTAinsuranceChannel (input) {
      this.searchMLIFTAinsuranceChannelLoading = true
      if (!input || input.length <= 0) {
        this.searchMLIFTAinsuranceChannelList = []
        this.searchMLIFTAinsuranceChannelLoading = false
      } else {
        store.dispatch('InsuranceChannelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchMLIFTAinsuranceChannelList = store.getters.get_InsuranceChannel_SearchByNameResult ? store.getters.get_InsuranceChannel_SearchByNameResult : []
          this.searchMLIFTAinsuranceChannelLoading = false
        }).catch(err => {
          this.searchMLIFTAinsuranceChannelLoading = false
        })
      }
    },
    searchTIinsuranceChannel (input) {
      this.searchTIinsuranceChannelLoading = true
      if (!input || input.length <= 0) {
        this.searchTIinsuranceChannelList = []
        this.searchTIinsuranceChannelLoading = false
      } else {
        store.dispatch('InsuranceChannelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchTIinsuranceChannelList = store.getters.get_InsuranceChannel_SearchByNameResult ? store.getters.get_InsuranceChannel_SearchByNameResult : []
          this.searchTIinsuranceChannelLoading = false
        }).catch(err => {
          this.searchTIinsuranceChannelLoading = false
        })
      }
    },
    onOk () {
      if (this.replaceDeviceOrder.vehicleInfo.vehicleType.name == null) {
        this.$Message.error('请输入车辆类型')
        return
      }
      if (this.replaceDeviceOrder.receptDatetime == '是') {
        this.replaceDeviceOrder.receptDatetime = new Date()
      } else {
        this.replaceDeviceOrder.receptDatetime = null
      }
      if (this.replaceDeviceOrder.urgent == '是') {
        this.replaceDeviceOrder.urgent = true
      } else {
        this.replaceDeviceOrder.urgent = false
      }
      this.$Modal.confirm({
        title: '添加安装订单信息',
        content: '<p>添加安装订单信息</p>',
        onOk: () => {
          store.dispatch('ReplaceDeviceOrderServ_AddObj', { params: this.replaceDeviceOrder }).then(() => {
            this.$Message.success('添加安装订单信息')
            this.AddPositioningDeviceFittingsModal = true
            this.AddPositioningDeviceFittingsModalId = store.getters.get_ReplaceDeviceOrder_AddObjResult.id
            this.cleanData()
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.isok = null
        // this.replaceDeviceOrder.totalAmount = null
        // this.replaceDeviceOrder.serviceDatetime = null
        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [7] }
        }).then(() => {
          this.businessUsers = store.getters.get_User_GetAllUsersResult
        }).catch(err => {
          this.$Message.error(err)
        })

        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [8, 14] }
        }).then(() => {
          this.installers = store.getters.get_User_GetAllUsersResult
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    },
    // onCheckClick(e){
    //   console.log('查询运营资格')
    //   console.log(e)
    //   store.dispatch('VehicleInfoServ_InquireOperation',{
    //     params:{
    //       registrationNum : e
    //     }
    //   }).then(res=>{
    //     console.log(store.getters.get_VehicleInfo_InquireOperationResult)
    //     if (store.getters.get_VehicleInfo_InquireOperationResult) {
    //       this.isok=true
    //     }else {
    //       this.isok=false
    //     }
    //   }).catch(err=>{
    //     this.isok=false
    //     console.log(err)
    //     this.$Message.error(err)
    //   })
    // },
    changedata3 () {
      this.content = []
      this.data3 = []
      if (!this.replaceDeviceOrder.vehicleInfo.registrationNum || this.replaceDeviceOrder.vehicleInfo.registrationNum === '') {
      } else {
        store.dispatch('VehicleInfoServ_SearchByName', {
          params: {
            name: this.replaceDeviceOrder.vehicleInfo.registrationNum
          },
          urlparams: null
        }).then(res => {
          this.list = res.data

          // this.data3 = []
          let result = []
          for (let i = 0; i < this.list.length; i++) {
            let str = this.list[i].registrationNum === null ? this.list[i].vin : this.list[i].registrationNum
            if (str.toUpperCase().indexOf(this.replaceDeviceOrder.vehicleInfo.registrationNum.toUpperCase()) !== -1) {
              result.push(str)
            }

            if (this.list[i].customName) {
              let str1 = this.list[i].customName
              if (str1.toUpperCase().indexOf(this.replaceDeviceOrder.vehicleInfo.registrationNum.toUpperCase()) !== -1) {
                result.push(str1)
              }
            }
          }
          let length = result.length > 10 ? 10 : result.length
          for (let i = 0; i < length; i++) {
            this.data3.push(result[i])
          }
        }).catch(err => {
          console.log(err)
          this.$Message.error(err)
        })
      }
    },

    filterMethod () {
      this.onSearchClickdisabled = false

      return true
    },
    selectvehicle (e) {
      console.log(e)
      // this.onCheckClick(e)
      store.dispatch('VehicleInfoServ_SearchByName', {
        params: {
          name: e
        },
        urlparams: null
      }).then(res => {
        console.log(res)
        console.log(store.getters.get_VehicleInfo_SearchByNameResult)
        let vehicleinfo = null
        store.getters.get_VehicleInfo_SearchByNameResult.forEach(item => {
          if (e === item.registrationNum) {
            vehicleinfo = item
          } else {
            vehicleinfo = store.getters.get_VehicleInfo_SearchByNameResult[0]
          }
        })
        console.log(vehicleinfo)
        // let vehicleinfo = store.getters.get_VehicleInfo_SearchByNameResult[0]
        if (vehicleinfo) {
          this.replaceDeviceOrder.businessType = 3
          this.content = []
          if (vehicleinfo) {
            if (vehicleinfo.positioningDeviceInfos) {
              vehicleinfo.positioningDeviceInfos.forEach(item => {
                this.content.push(item)
              })
            }
          } else {
            this.content = []
          }
          this.replaceDeviceOrder.vehicleInfoId = vehicleinfo.id

          this.replaceDeviceOrder.vehicleInfo.customName = vehicleinfo.customName
          this.replaceDeviceOrder.vehicleInfo.registrationNum = vehicleinfo.registrationNum
          this.replaceDeviceOrder.vehicleInfo.registrationColor = vehicleinfo.registrationColor
          this.replaceDeviceOrder.vehicleInfo.vin = vehicleinfo.vin
          this.replaceDeviceOrder.vehicleInfo.bodyColor = vehicleinfo.bodyColor
          this.searchVehicleTypeList = []
          if (vehicleinfo.vehicleTypeId != null) {
            store.dispatch('VehicleTypeServ_GetDetail', {
              params: { id: vehicleinfo.vehicleTypeId },
              urlparams: null
            }).then(() => {
              this.searchVehicleTypeList.push(store.getters.get_VehicleType_GetDetailResult ? store.getters.get_VehicleType_GetDetailResult : [])
              this.searchVehicleTypeLoading = false
            }).catch(err => {
              this.searchVehicleTypeLoading = false
            })
            // this.replaceDeviceOrder.vehicleInfo.vehicleType.id = vehicleinfo.vehicleTypeId
            // this.replaceDeviceOrder.vehicleInfo.vehicleType.name = vehicleinfo.vehicleType.name
          } else {
            this.replaceDeviceOrder.vehicleInfo.vehicleType.id = null
            // this.replaceDeviceOrder.vehicleInfo.vehicleType.name = null
          }
          this.searchVehicleBrandList = []
          if (vehicleinfo.vehicleBrandId != null) {
            store.dispatch('VehicleBrandServ_GetDetail', {
              params: { id: vehicleinfo.vehicleBrandId },
              urlparams: null
            }).then(() => {
              this.searchVehicleBrandList.push(store.getters.get_VehicleBrand_GetDetailResult ? store.getters.get_VehicleBrand_GetDetailResult : [])
              this.searchVehicleBrandLoading = false
            }).catch(err => {
              this.searchVehicleBrandLoading = false
            })
            // this.replaceDeviceOrder.vehicleInfo.vehicleBrand.id = vehicleinfo.vehicleBrandId
            // this.replaceDeviceOrder.vehicleInfo.vehicleBrand.name = vehicleinfo.vehicleBrand.name
          } else {
            this.replaceDeviceOrder.vehicleInfo.vehicleBrand.id = null
            this.replaceDeviceOrder.vehicleInfo.vehicleBrand.name = null
          }
          this.replaceDeviceOrder.vehicleInfo.engineNum = vehicleinfo.engineNum
          this.replaceDeviceOrder.vehicleInfo.vehicleLicenseNum = vehicleinfo.vehicleLicenseNum
          this.replaceDeviceOrder.vehicleInfo.unladenMass = vehicleinfo.unladenMass
          this.replaceDeviceOrder.vehicleInfo.approvedLoad = vehicleinfo.approvedLoad
          this.searchVehicleOwnerInfoList = []
          if (vehicleinfo.vehicleOwnerInfoId) {
            store.dispatch('VehicleOwnerInfoServ_GetDetail', {
              params: {
                id: vehicleinfo.vehicleOwnerInfoId
              },
              urlparams: null
            }).then(res => {
              this.searchVehicleOwnerInfoList.push(store.getters.get_VehicleOwnerInfo_GetDetailResult ? store.getters.get_VehicleOwnerInfo_GetDetailResult : [])
              this.searchVehicleOwnerInfoLoading = false
            }).catch(err => {
              this.searchVehicleOwnerInfoLoading = false
              console.log(err)
            })
          }
          this.replaceDeviceOrder.vehicleInfo.vehicleOwnerInfoId = vehicleinfo.vehicleOwnerInfoId
          this.searchClientInfoList = []
          if (vehicleinfo.clientInfoId) {
            store.dispatch('ClientInfoServ_GetDetail', {
              params: { id: vehicleinfo.clientInfoId },
              urlparams: null
            }).then(() => {
              this.searchClientInfoList.push(store.getters.get_ClientInfo_GetDetailResult ? store.getters.get_ClientInfo_GetDetailResult : [])
              this.searchClientInfoLoading = false
            }).catch(err => {
              this.searchClientInfoLoading = false
            })
          }
          this.replaceDeviceOrder.vehicleInfo.clientInfoId = vehicleinfo.clientInfoId
          this.replaceDeviceOrder.vehicleInfo.servicePassword = vehicleinfo.servicePassword
          this.replaceDeviceOrder.vehicleInfo.vehicleLicenseDistributeDatetime = vehicleinfo.vehicleLicenseDistributeDatetime
          this.replaceDeviceOrder.vehicleInfo.vehicleLicenseReigsterDatetime = vehicleinfo.vehicleLicenseReigsterDatetime
          this.replaceDeviceOrder.vehicleInfo.remark = vehicleinfo.remark
          this.replaceDeviceOrder.vehicleInfo.certificateNum = vehicleinfo.certificateNum
          this.replaceDeviceOrder.vehicleInfo.certificateDistributeDatetime = vehicleinfo.certificateDistributeDatetime
          if (vehicleinfo.vehicleModelId != null) {
            this.replaceDeviceOrder.vehicleInfo.vehicleModel.id = vehicleinfo.vehicleModelId
            // this.replaceDeviceOrder.vehicleInfo.vehicleModel.name = vehicleinfo.vehicleModel.name
          } else {
            this.replaceDeviceOrder.vehicleInfo.vehicleModel.id = null
            this.replaceDeviceOrder.vehicleInfo.vehicleModel.name = null
          }
          this.replaceDeviceOrder.vehicleInfo.chassisModel = vehicleinfo.chassisModel
          this.replaceDeviceOrder.vehicleInfo.chassisId = vehicleinfo.chassisId
          this.replaceDeviceOrder.vehicleInfo.chassisCertificateNum = vehicleinfo.chassisCertificateNum
          this.replaceDeviceOrder.vehicleInfo.engineModel = vehicleinfo.engineModel
          this.replaceDeviceOrder.vehicleInfo.energyType = vehicleinfo.energyType
          this.replaceDeviceOrder.vehicleInfo.displacement = vehicleinfo.displacement
          this.replaceDeviceOrder.vehicleInfo.power = vehicleinfo.power
          this.replaceDeviceOrder.vehicleInfo.energyUsage = vehicleinfo.energyUsage
          this.replaceDeviceOrder.vehicleInfo.emissionStandard = vehicleinfo.emissionStandard
          this.replaceDeviceOrder.vehicleInfo.manufacturer = vehicleinfo.manufacturer
          this.replaceDeviceOrder.vehicleInfo.outlineSizeLong = vehicleinfo.outlineSizeLong
          this.replaceDeviceOrder.vehicleInfo.outlineSizeWidth = vehicleinfo.outlineSizeWidth
          this.replaceDeviceOrder.vehicleInfo.outlineSizeHeight = vehicleinfo.outlineSizeHeight
          this.replaceDeviceOrder.vehicleInfo.boxSizeLong = vehicleinfo.boxSizeLong
          this.replaceDeviceOrder.vehicleInfo.boxSizeWidth = vehicleinfo.boxSizeWidth
          this.replaceDeviceOrder.vehicleInfo.boxSizeHeight = vehicleinfo.boxSizeHeight
          this.replaceDeviceOrder.vehicleInfo.springPieceCount = vehicleinfo.springPieceCount
          this.replaceDeviceOrder.vehicleInfo.tyreCount = vehicleinfo.tyreCount
          this.replaceDeviceOrder.vehicleInfo.tyreSpec = vehicleinfo.tyreSpec
          this.replaceDeviceOrder.vehicleInfo.wheelSpanFront = vehicleinfo.wheelSpanFront
          this.replaceDeviceOrder.vehicleInfo.wheelSpanBack = vehicleinfo.wheelSpanBack
          this.replaceDeviceOrder.vehicleInfo.wheelBase = vehicleinfo.wheelBase
          this.replaceDeviceOrder.vehicleInfo.axisLoad = vehicleinfo.axisLoad
          this.replaceDeviceOrder.vehicleInfo.axisCount = vehicleinfo.axisCount
          this.replaceDeviceOrder.vehicleInfo.turnType = vehicleinfo.turnType
          this.replaceDeviceOrder.vehicleInfo.totalMass = vehicleinfo.totalMass
          this.replaceDeviceOrder.vehicleInfo.approvedLoadCoefficient = vehicleinfo.approvedLoadCoefficient
          this.replaceDeviceOrder.vehicleInfo.towMax = vehicleinfo.towMax
          this.replaceDeviceOrder.vehicleInfo.saddleMax = vehicleinfo.saddleMax
          this.replaceDeviceOrder.vehicleInfo.cabPeopleCount = vehicleinfo.cabPeopleCount
          this.replaceDeviceOrder.vehicleInfo.mannedCount = vehicleinfo.mannedCount
          this.replaceDeviceOrder.vehicleInfo.speedMax = vehicleinfo.speedMax
          this.replaceDeviceOrder.vehicleInfo.productionDatetime = vehicleinfo.productionDatetime
          this.replaceDeviceOrder.vehicleInfo.certificateRemark = vehicleinfo.certificateRemark
          this.replaceDeviceOrder.vehicleInfo.vehicleLicensePictureId = vehicleinfo.vehicleLicensePictureId
          this.replaceDeviceOrder.vehicleInfo.certificatePictureId = vehicleinfo.certificatePictureId
          this.replaceDeviceOrder.vehicleInfo.vehicleSrcLicensePicture1Id = vehicleinfo.vehicleSrcLicensePicture1Id
          this.replaceDeviceOrder.vehicleInfo.vehicleSrcLicensePicture2Id = vehicleinfo.vehicleSrcLicensePicture2Id
          this.replaceDeviceOrder.vehicleInfo.vehicleBodyPictureId = vehicleinfo.vehicleBodyPictureId
          this.replaceDeviceOrder.vehicleInfo.test = false
          this.replaceDeviceOrder.vehicleInfo.vehicleUse = vehicleinfo.vehicleUse
          this.replaceDeviceOrder.vehicleInfo.attention = vehicleinfo.attention

          this.replaceDeviceOrder.businessUserId = vehicleinfo.businessUserId
          this.replaceDeviceOrder.clientInfoId = vehicleinfo.clientInfoId
          this.searchVehicleInfoGroupList = []
          if (vehicleinfo.vehicleInfoGroupId) {
            store.dispatch('VehicleInfoGroupServ_GetDetail', {
              params: { id: vehicleinfo.vehicleInfoGroupId },
              urlparams: null
            }).then(() => {
              this.searchVehicleInfoGroupList.push(store.getters.get_VehicleInfoGroup_GetDetailResult ? store.getters.get_VehicleInfoGroup_GetDetailResult : [])
              this.searchVehicleInfoGroupLoading = false
            }).catch(err => {
              this.searchVehicleInfoGroupLoading = false
            })
          }
          this.replaceDeviceOrder.vehicleInfoGroupId = vehicleinfo.vehicleInfoGroupId

          console.log(this.replaceDeviceOrder)
        }
      }).catch(err => {
        console.log(err)
        this.$Message.error(err)
      })
    },
    cleanData () {
      this.replaceDeviceOrder.vehicleInfoId = null
      this.replaceDeviceOrder.vehicleInfo.customName = null
      this.replaceDeviceOrder.vehicleInfo.registrationNum = null
      this.replaceDeviceOrder.vehicleInfo.registrationColor = null
      this.replaceDeviceOrder.vehicleInfo.vin = null
      this.replaceDeviceOrder.vehicleInfo.bodyColor = null
      this.replaceDeviceOrder.vehicleInfo.vehicleType.name = null
      this.replaceDeviceOrder.vehicleInfo.vehicleBrand.name = null
      this.replaceDeviceOrder.vehicleInfo.engineNum = null
      this.replaceDeviceOrder.vehicleInfo.vehicleLicenseNum = null
      this.replaceDeviceOrder.vehicleInfo.unladenMass = null
      this.replaceDeviceOrder.vehicleInfo.approvedLoad = null
      this.replaceDeviceOrder.vehicleInfo.vehicleOwnerInfoId = null
      this.replaceDeviceOrder.vehicleInfo.clientInfoId = null
      this.replaceDeviceOrder.vehicleInfo.servicePassword = null
      this.replaceDeviceOrder.vehicleInfo.vehicleLicenseDistributeDatetime = null
      this.replaceDeviceOrder.vehicleInfo.vehicleLicenseReigsterDatetime = null
      this.replaceDeviceOrder.vehicleInfo.remark = null
      this.replaceDeviceOrder.vehicleInfo.certificateNum = null
      this.replaceDeviceOrder.vehicleInfo.certificateDistributeDatetime = null
      this.replaceDeviceOrder.vehicleInfo.vehicleModel.name = null
      this.replaceDeviceOrder.vehicleInfo.chassisModel = null
      this.replaceDeviceOrder.vehicleInfo.chassisId = null
      this.replaceDeviceOrder.vehicleInfo.chassisCertificateNum = null
      this.replaceDeviceOrder.vehicleInfo.engineModel = null
      this.replaceDeviceOrder.vehicleInfo.energyType = null
      this.replaceDeviceOrder.vehicleInfo.displacement = null
      this.replaceDeviceOrder.vehicleInfo.power = null
      this.replaceDeviceOrder.vehicleInfo.energyUsage = null
      this.replaceDeviceOrder.vehicleInfo.emissionStandard = null
      this.replaceDeviceOrder.vehicleInfo.manufacturer = null
      this.replaceDeviceOrder.vehicleInfo.outlineSizeLong = null
      this.replaceDeviceOrder.vehicleInfo.outlineSizeWidth = null
      this.replaceDeviceOrder.vehicleInfo.outlineSizeHeight = null
      this.replaceDeviceOrder.vehicleInfo.boxSizeLong = null
      this.replaceDeviceOrder.vehicleInfo.boxSizeWidth = null
      this.replaceDeviceOrder.vehicleInfo.boxSizeHeight = null
      this.replaceDeviceOrder.vehicleInfo.springPieceCount = null
      this.replaceDeviceOrder.vehicleInfo.tyreCount = null
      this.replaceDeviceOrder.vehicleInfo.tyreSpec = null
      this.replaceDeviceOrder.vehicleInfo.wheelSpanFront = null
      this.replaceDeviceOrder.vehicleInfo.wheelSpanBack = null
      this.replaceDeviceOrder.vehicleInfo.wheelBase = null
      this.replaceDeviceOrder.vehicleInfo.axisLoad = null
      this.replaceDeviceOrder.vehicleInfo.axisCount = null
      this.replaceDeviceOrder.vehicleInfo.turnType = null
      this.replaceDeviceOrder.vehicleInfo.totalMass = null
      this.replaceDeviceOrder.vehicleInfo.approvedLoadCoefficient = null
      this.replaceDeviceOrder.vehicleInfo.towMax = null
      this.replaceDeviceOrder.vehicleInfo.saddleMax = null
      this.replaceDeviceOrder.vehicleInfo.cabPeopleCount = null
      this.replaceDeviceOrder.vehicleInfo.mannedCount = null
      this.replaceDeviceOrder.vehicleInfo.speedMax = null
      this.replaceDeviceOrder.vehicleInfo.productionDatetime = null
      this.replaceDeviceOrder.vehicleInfo.certificateRemark = null
      this.replaceDeviceOrder.vehicleInfo.vehicleLicensePictureId = null
      this.replaceDeviceOrder.vehicleInfo.certificatePictureId = null
      this.replaceDeviceOrder.vehicleInfo.vehicleSrcLicensePicture1Id = null
      this.replaceDeviceOrder.vehicleInfo.vehicleSrcLicensePicture2Id = null
      this.replaceDeviceOrder.vehicleInfo.vehicleBodyPictureId = null
      this.replaceDeviceOrder.vehicleInfo.test = false
      this.replaceDeviceOrder.vehicleInfo.vehicleUse = null
      this.searchVehicleTypeList = []
      this.searchVehicleBrandList = []
      this.searchVehicleOwnerInfoList = []
      this.searchClientInfoList = []
      this.searchVehicleInfoGroupList = []
      this.searchMLIFTAinsuranceChannelList = []
      this.searchTIinsuranceChannelList = []
      this.replaceDeviceOrder.vehicleInfo.mliftainsuranceChannelId = null
      this.replaceDeviceOrder.vehicleInfo.mliftainsurancechannelDatetime = null
      this.replaceDeviceOrder.vehicleInfo.tiinsuranceChannelId = null
      this.replaceDeviceOrder.vehicleInfo.tiinsurancechannelDatetime = null
      this.replaceDeviceOrder.vehicleInfo.insured = null
      this.replaceDeviceOrder.urgent = null
      this.replaceDeviceOrder.receptDatetime = null
      this.replaceDeviceOrder.stepId = null
      this.replaceDeviceOrder.step = null
      this.replaceDeviceOrder.bookingDatetime = null
      this.replaceDeviceOrder.bookingPlace = null
      this.replaceDeviceOrder.actualDatetime = null
      this.replaceDeviceOrder.actualPlace = null
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        registrationNum: this.registrationNumRules,
        color: this.colorRules,
        vin: this.vinRules,
        totalAmount: this.totalAmountRules,
        serviceDateNum: this.serviceDateNumRules,
        businessType: this.businessTypeRules,
        vehicleTypeName: this.vehicleTypeNameRules,
        businessUserId: this.businessUserIdRules,
        qghyptOption: this.qghyptOptionRules,
        billType: this.billTypeRules,
        isfree: this.isfreeRules,
        clientInfoId: this.clientInfoIdRules,
        vehicleOwnerInfoId: this.vehicleOwnerInfoIdRules
      }
    }
    // content () {
    //   if (store.getters.get_VehicleInfo_SearchByNameResult) {
    //     return store.getters.get_VehicleInfo_SearchByNameResult[0].positioningDeviceInfos
    //   } else {
    //     return []
    //   }
    // },
  },
  mounted () {
    this.$nextTick(() => {
      store.dispatch('PositioningDeviceTypeServ_GetAll', {

      }).then(res => {
        if (store.getters.get_PositioningDeviceType_GetAllResult) {
          store.getters.get_PositioningDeviceType_GetAllResult.forEach(item => {
            this.positioningDeviceModelOptions.push({ label: item.name, value: item.id })
          })
        }
      }).catch(err => {
        console.log(err)
        this.$Message.error(err)
      })
    })
  }
}
</script>

<style scoped>

  .field {
    margin-left: 5px;
    width: 70%;
  }
</style>
